import React, { useState } from "react"
import BlockWrapper from "@yumgmbh/gatsby-theme-yum-components/src/components/technical/BlockWrapper"
import Image from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Image"
import Richtext from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Richtext"
import Link from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Link"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowRightLong } from "@fortawesome/pro-solid-svg-icons"

const TabsBackgroundBlock = ({ block }) => {
  const [activeTabState, setActiveTabState] = useState(1)

  //block.view = "bg_image"

  return (
    <BlockWrapper blockWidth="container" block={block} showHeadline="true">
      <div className="relative mt-8 overflow-hidden rounded-xl h-screen-90">
        {block.tab_items &&
          block.tab_items.length > 0 &&
          block.tab_items.map((item, index) =>
            block.view === "bg_color" ? (
              <div
                className={`absolute inset-0  ${item.bg_color}  ${
                  activeTabState === index + 1 ? "z-10" : ""
                }`}
              ></div>
            ) : (
              <div
                className={`absolute inset-0 transition-all duration-1000 ${
                  activeTabState === index + 1
                    ? "z-10 bg-opacity-100"
                    : "bg-opacity-0"
                }`}
              >
                <Image
                  className="object-cover w-full h-full"
                  image={item.image}
                />
              </div>
            )
          )}
        {block.view === "bg_image" && (
          <div className="absolute inset-0 z-20 bg-black bg-opacity-50"></div>
        )}

        <div className="absolute inset-0 z-30">
          <div className="h-full py-4 mx-auto lg:py-8 max-w-screen-lg mx-auto px-grid">
            <nav className="block md:inline-block w-auto overflow-hidden bg-white border border-white rounded-xl">
              {block.tab_items &&
                block.tab_items.length > 0 &&
                block.tab_items.map((item, index) => (
                  <button
                    className={`inline-block w-1/2 md:w-auto py-2 px-grid  ${
                      activeTabState === index + 1
                        ? "bg-primary text-white pointer-events-none"
                        : "text-primary "
                    } transition-colors duration-300 hover:bg-gray-300`}
                    onClick={() => setActiveTabState(index + 1)}
                    active
                    key={index}
                  >
                    {item.title}
                  </button>
                ))}
            </nav>
            <div className="relative w-full pb-4">
              {block.tab_items &&
                block.tab_items.length > 0 &&
                block.tab_items.map((item, index) => (
                  <div
                    key={index}
                    className={`text-white ${
                      activeTabState === index + 1 ? "block" : "hidden"
                    } `}
                  >
                    <div className="pt-8">
                      <div className="flex flex-row flex-wrap -mx-grid">
                        {item.image?.filename?.length > 0 && (
                          <div className="w-full md:w-1/2 md:order-last px-grid">
                            <div className="mb-4 overflow-hidden border border-white rounded-xl">
                              <Image
                                className="w-full h-auto"
                                aspectRatio="16by9"
                                image={item.image}
                              />
                            </div>
                          </div>
                        )}
                        <div
                          className={`w-full ${
                            item.image?.filename?.length > 0 ? "md:w-1/2" : ""
                          } px-grid`}
                        >
                          {item.headline?.length > 0 && (
                            <h3 className="headline headline-h2">
                              {item.headline}
                            </h3>
                          )}
                          {item.text?.length > 0 && (
                            <Richtext className="mt-4" text={item.text} />
                          )}
                          {item.link?.cached_url?.length > 0 && (
                            <Link
                              className="inline-block mt-4 hover:text-primary-100"
                              link={item.link}
                            >
                              <FontAwesomeIcon
                                icon={faArrowRightLong}
                                size="1x"
                                className="mr-2"
                              />
                              {item.link_text}
                            </Link>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </BlockWrapper>
  )
}

export default TabsBackgroundBlock
